/**
 * Модуль локализации приложения
 */
import { translations } from './locales';

// Функция для перевода строк
export function t(key: string, replacements: Record<string, string | number> = {}): string {
  let text = translations[key] || key;
  
  // Замена плейсхолдеров в строке если они есть
  Object.entries(replacements).forEach(([key, value]) => {
    text = text.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value));
  });
  
  return text;
}

// Форматирование дат с учетом локали
export function formatDate(date: Date | string | null): string {
  if (!date) return '';
  
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  return dateObj.toLocaleDateString('ru-RU', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

// Форматирование чисел с учетом локали
export function formatNumber(num: number): string {
  return num.toLocaleString('ru-RU');
}